import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { IBreadcrumbsProps } from './IBreadcrumbsProps';
import './breadcrumbs.css';

/**
 * Крихти «Робочий простір › Група › Модуль (› Таблиця › Запис)» над вмістом сторінки (layout/breadcrumbs): кожен рівень, крім останнього, —
 * посилання; останній — поточна сторінка (aria-current, 600, обрізається з «…» і повним текстом у підказці). Один рівень не показується.
 */
export function Breadcrumbs({ items }: IBreadcrumbsProps) {
  const { t } = useTranslation();
  if (items.length < 2) return null;
  return (
    <nav className="crumbs" aria-label={t('shell.breadcrumbs')}>
      <ol className="crumbs__list">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${i}-${c.label}`} className="crumbs__item">
              {i > 0 && <span className="crumbs__sep" aria-hidden="true">›</span>}
              {!last && c.to
                ? <Link className="crumbs__link" to={c.to}>{c.label}</Link>
                : <span className={last ? 'crumbs__current' : 'crumbs__text'} aria-current={last ? 'page' : undefined} title={c.label}>{c.label}</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
